<template>
  <v-tooltip bottom v-model="show">
    <template #activator="{ on: onTooltip }">
      <v-btn icon v-on="{ ...onTooltip }" @click="print" class="d-print-none">
        <v-icon>mdi-printer</v-icon>
      </v-btn>
    </template>
    <span>Ouvrir la fenêtre d'impression</span>
  </v-tooltip>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    print() {
      this.show = false;
      //on met un timeout pour laisser du temps au tooltip de disparaitre
      setTimeout(() => window.print(), 50);
    },
  },
};
</script>
